module.exports = __webpack_public_path__ + "static/media/Nunito-Light.b156cb38.ttf";